<template>
  <div
    class="
      $typography/size:small
      layout/flex
      layout/relative
      layout/padding:cap
      layout/margin:cap:-1
      link/focus
    "
    @mouseover="hover = true"
    @mouseleave="hover = false"
    >
    <select
      :id="id"
      v-model="selected"
      class="
        link/cursor
        layout/absolute
        layout/bottom:0%
        layout/left:0%
        layout/margin:clear
        layout/opacity:0%
        layout/right:0%
        layout/top:0%
        layout/width:100%
        typography
      "
      :name="name"
      @change="performSelectionFunc(selected)"
      >
      <option
        v-for="(tag, index) in optionsKeys"
        :key="`${tag}-${index}`"
        :value="tag"
        >
        {{ options[tag] }}
      </option>
    </select>
    <label
      :class="[
        '$motion/transition:opacity:curve:linear',
        '$motion/transition:opacity:duration:100ms',
        hoverColor,
        'layout/align:center',
        'layout/flex:row',
        'layout/grid:gap:column:cap:0.5',
        'layout/height:cap',
        'motion/transition',
      ]"
      :for="id"
      >
      <icon
        icon-name="icon__globe--24.svg"
        :class-name="[
          hoverColor,
          'typography/icon',
          'link/disable'
        ]"
      />
      <span
        class="
          typography
        "
        >
        <nobr>
          {{ selectedValue }}
        </nobr>
      </span>
    </label>
  </div>
</template>

<script>
import icon from '../icons/icon.vue';

export default {
  props: {
    id: {type: String},
    name: { type: String},
    collection: { type: String },
    collectionKeys: { type: Array },
    selectedFunc: { type: Function },
    selectionFunc: { type: Function },
  },
  data: function() {
    return {
      selected: this.selectedFunc(),
      hover: false,
    };
  },
  computed: {
    options: function() {
      return JSON.parse(this.collection);
    },
    optionsKeys: function() {
      return this.collectionKeys;
    },
    selectedValue: function() {
      return this.options[this.selected];
    },
    hoverColor: function() {
      return this.hover ? null : '$color/gray:666';
    },
  },
  methods: {
    performSelectionFunc: function(selected) {
      return this.selectionFunc(selected);
    },
  },
  components: {
    icon,
  }
}
</script>
